'use client';

import { CustomDrawer } from './CustomDrawer';
import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { useLeftSidebarStore } from '@efacity/frontend-next-shared/header';

export function LeftNavigation({ children }: { children: ReactNode }) {
  const setIsExpanded = useLeftSidebarStore((state) => state.setLeftNavExpanded);
  const isExpanded = useLeftSidebarStore((state) => state.isExpanded);

  return (
    <CustomDrawer
      isExpanded={isExpanded}
      onExpand={() => {
        setIsExpanded(true);
      }}
      onMinimize={() => {
        setIsExpanded(false);
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'space-between',
          overflow: 'auto'
        }}
      >
        {children}
      </Box>
    </CustomDrawer>
  );
}
